import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, skip } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  private hasHistory = false;

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      skip(1) // skip initial routing event on page load
    )
      .subscribe(() => {
        this.hasHistory = true;
      });
  }

  back(): void {
    // Auskommentiert, da damit mehr Fälle abgedeckt werden können / mas 27.01.2021
    // if (this.hasHistory) {
      this.location.back();
    // } else {
      // this.router.navigateByUrl('/');
    // }
  }
}
